import { ctaContent } from '@/mocks/content';
import { mainSiteUrl } from '@/mocks/categories';

export default function CTASection() {
  return (
    <section className="relative w-full py-20 md:py-28 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dark%20moody%20fashion%20product%20still%20life%20with%20sneakers%20leather%20bag%20and%20folded%20clothing%20on%20deep%20charcoal%20surface%20dramatic%20side%20lighting%20warm%20amber%20highlights%20luxury%20editorial%20aesthetic%20high%20contrast&width=1800&height=800&seq=cta-v3-bg&orientation=landscape"
        alt="Prodotti Itaobuy Spreadsheet"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60"></div>
      <div className="absolute inset-0 bg-black/15"></div>

      <div className="relative z-10 px-4 md:px-6 lg:px-10 max-w-[1280px] mx-auto">
        <div className="flex flex-col items-start">
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-[1.08] max-w-2xl mb-6"
            style={{ textShadow: '0 2px 12px rgba(0,0,0,0.45)' }}
          >
            {ctaContent.title}
          </h2>
          <p className="text-sm md:text-base text-white/85 max-w-md leading-relaxed mb-8 font-light"
            style={{ textShadow: '0 1px 6px rgba(0,0,0,0.4)' }}
          >
            {ctaContent.subtitle}
          </p>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-3 px-8 py-4 rounded-full bg-white text-foreground-900 text-sm md:text-base font-semibold whitespace-nowrap cursor-pointer hover:bg-white/95 transition-all duration-300 group"
          >
            {ctaContent.button}
            <span className="w-7 h-7 rounded-full bg-primary-500 flex items-center justify-center transition-transform duration-300 group-hover:translate-x-0.5">
              <i className="ri-arrow-right-line text-white text-sm"></i>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}